import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  LOCAL_STORAGE,
  getDataSession,
  setDataSession,
} from "../../helper/session";

const useChangeLanguage = () => {
  const localLanguage = getDataSession(LOCAL_STORAGE, "languageCode");

  const { i18n } = useTranslation();

  const changeLanguage = async (lang) => {
    setDataSession(LOCAL_STORAGE, "languageCode", lang);
    i18n.changeLanguage(lang);
    // toast.success(t(`message.change-lang-succ`));
  };

  useEffect(() => {
    i18n.changeLanguage(localLanguage ?? "eng");
    if (!localLanguage) {
      setDataSession(LOCAL_STORAGE, "languageCode", "eng");
    }
  }, []);

  return { changeLanguage };
};

export default useChangeLanguage;
